import { Badge } from '@/components/ui/badge';
import { MeetingStatus, MeetingStatusLabelMap } from '@airreading/common/data';
import clsx from 'clsx';

interface MeetingStatusBadgeProps {
  status: MeetingStatus | null;
  'data-testid'?: string;
}

const MeetingStatusColorMap: Record<MeetingStatus, string> = {
  [MeetingStatus.waiting]: 'bg-orange-600',
  [MeetingStatus.started]: 'bg-green-600',
  [MeetingStatus.ended]: 'bg-slate-600',
  [MeetingStatus.canceled]: 'bg-slate-600',
};

export function MeetingStatusBadge({ status, 'data-testid': dataTestId }: MeetingStatusBadgeProps) {
  if (!status) {
    return null;
  }

  const colorClass = MeetingStatusColorMap[status];
  const label = MeetingStatusLabelMap[status];

  return (
    <Badge className={clsx(colorClass)} data-testid={dataTestId}>
      {label}
    </Badge>
  );
}
